export default __webpack_public_path__ + "static/media/c-try-free-box-rock.591c393a.png";